import CheckoutInfoCard from "./CheckoutInfoCard";

export default CheckoutInfoCard;
